window.googleMapsDarkStyles = [
	{
		elementType: 'geometry',
		stylers: [
			{
				color: '#222222', // The "squares" (land blocks) are now grey
			},
		],
	},
	{
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#4a4a4a',
			},
		],
	},
	{
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#222222',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#1b1b1b', // The "streets" are now black
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#1b1b1b',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [
			{
				color: '#1b1b1b',
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry',
		stylers: [
			{
				color: '#1b1b1b',
			},
		],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry',
		stylers: [
			{
				color: '#1b1b1b',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [
			{
				color: '#1a1a1a',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [ { visibility: 'off' } ],
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [ { visibility: 'off' } ],
	},
	{
		featureType: 'road',
		elementType: 'labels.icon',
		stylers: [ { visibility: 'off' } ],
	},
];
